import React, { Component } from "react";
import { Field, Formik, Form } from "formik";
import { ClipLoader } from "react-spinners";
import swal from "sweetalert";
import { service as dashboard_service } from "../redux";
import Select from "react-select";
import { utils } from "~/utils";

class OpenRunVsPendencyReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoadig: false,
            input_circles_value: ""
        };
    }

    render() {
        return (
            <div>
                <div className="row justify-content-center">
                    <div className="col-md-6">
                        <Formik onSubmit={values => this.handleSubmit(values)}>
                            {formik => {
                                const { values, setFieldValue } = formik;
                                return (
                                    <Form>
                                        <div className="form-group col-6">
                                            <label>Customer team</label>
                                            <Field
                                                name="customers_team_name"
                                                component={Select}
                                                value={values.customers_team_name}
                                                isClearable
                                                cacheOptions
                                                defaultOptions
                                                options={[
                                                    { value: "bharti_infratel_limited", label: "Bharti infratel limited" },
                                                    { value: "Indian_Railways", label: "Indian Railways" },
                                                    { value: "Alstom", label: "ALSTOM" },
                                                    { value: "MTNL", label: "MTNL" },
                                                    { value: "BSNL", label: "BSNL" },
                                                    { value: "vodafone_idea_limited_india", label: "Vodafone idea india" },
                                                    { value: "bharti_airtel_india_parser", label: "Bharti Airtel India" },
                                                    { value: "reliance_jio_parser", label: "Reliance Jio" },
                                                ]}
                                                onChange={val => setFieldValue("customers_team_name", val, false)}
                                            />
                                        </div>
                                        <button type="submit" className="btn btn-success">
                                            Download
                                        </button>
                                        {this.state.isLoadig && (
                                            <div className="float-right">
                                                <ClipLoader />
                                            </div>
                                        )}
                                    </Form>
                                );
                            }}
                        </Formik>
                    </div>
                </div>
            </div>
        );
    }

    handleSubmit = values => {
        let request = utils.clearObjectNulls({
            customers_team_name: values && values.customers_team_name ? values.customers_team_name.value : null,
            
        });
        const errorMessage = () => {
            swal({
                title: "Warning ...",
                text: "An error has occurred while trying to download the report",
                icon: "warning",
                button: true
            });
        };

        this.setState({ isLoadig: true });
        dashboard_service
            .getOpenRunVsPendencyReport(request)
            .then(() => this.setState({ isLoadig: false }))
            .catch(_ => {
                this.setState({ isLoadig: false });
                errorMessage();
            });
    };
}

export default OpenRunVsPendencyReport;
